import { ChangeEvent, FocusEvent } from 'react';
import {
  addNoMatchingEmailIssue,
  notValidEmailErrorMessage,
} from 'utils/validation/email';
import { requiredField } from 'utils/validation/required';
import { z } from 'zod';

/*********************************************************
 *                        TYPES                          *
 ********************************************************/

export type ContactDataFormType = z.infer<
  typeof contactDataStepFormValidationSchema
>;

export type ContactDataFormKeys = keyof ContactDataFormType;
/*********************************************************
 *                FIELD NAMES / MAPPINGS                 *
 ********************************************************/
export const emailField = 'email';
export const confirmEmailField = 'confirmEmail';
export const phonePrefixField = 'phonePrefix';
export const phoneNumberField = 'phoneNumber';
export const flagProfileField = 'flagProfile';
export const flagNewsletterField = 'flagNewsletter';
export const errorMessageToFieldNameMap: Record<string, ContactDataFormKeys> = {
  'verifyService.err.mail.alreadypresent': emailField,
  'verifyService.err.phoneNumber.alreadypresent': phoneNumberField,
};
/*********************************************************
 *                    DEFAULT VALUES                     *
 ********************************************************/
export const contactDataFormDefaultValues = {
  [emailField]: '',
  [confirmEmailField]: '',
  [phonePrefixField]: '+212',
  [phoneNumberField]: '',
  [flagProfileField]: false,
  [flagNewsletterField]: false,
};

/*********************************************************
 *                    VALIDATION SCHEMAS                 *
 ********************************************************/
export const emailSchema = requiredField.pipe(
  z
    .string()
    .email(notValidEmailErrorMessage)
    .min(6, 'error.minLength.6')
    .max(50, 'error.maxLength.50'),
);

export const mobilePhoneNumberSchema = requiredField.pipe(
  z.string().min(7, 'error.minLength.7').max(10, 'error.maxLength.10'),
);

export const contactDataStepFormValidationSchema = z
  .object({
    [emailField]: emailSchema,
    [confirmEmailField]: requiredField,
    [phonePrefixField]: requiredField,
    [phoneNumberField]: mobilePhoneNumberSchema,
    [flagProfileField]: z.boolean(),
    [flagNewsletterField]: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data[emailField] !== data[confirmEmailField]) {
      addNoMatchingEmailIssue(ctx, [confirmEmailField]);
    }
  });
